/**
 * @generated SignedSource<<6e8a5f5238705906948d30fc4fb12698>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpSellerDetails_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentType": "usePdpSellerDetails_user";
};
export type usePdpSellerDetails_user$key = {
  readonly " $data"?: usePdpSellerDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpSellerDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpSellerDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f801e1278da955fbc25910e27d7d55e8";

export default node;
